<div #inactivityCheckModal class="modal fade modal-confirmation" id="inactivityCheckModal" tabindex="-1"
    aria-labelledby="inactivityCheckModalLabel" aria-hidden="true" data-backdrop="static"  data-keyboard="false"
    data-bs-backdrop="static"  data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex">
                    <img class="mr-4" src="assets/icons/inactivityInformationOutlined.svg" />
                    <h5 class="modal-title fs-5" id="inactivityCheckModalLabel">{{ 'CHECK.INACTIVITY_MODAL_TITLE' | translate }}</h5>
                </div>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" (click)="continueEditing()">
                    <img src="assets/icons/closeInactivityOutlined.svg" />
                </button>
            </div>

            <div class="modal-body">
                <p>{{ 'CHECK.INACTIVITY_ALERT_MESSAGE_1' | translate }}</p>
                <p>{{ 'CHECK.INACTIVITY_ALERT_MESSAGE_2' | translate }} {{ countdown }} {{ 'CHECK.INACTIVITY_ALERT_MESSAGE_3' | translate }}</p>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="continueEditing()">{{ 'CHECK.CONTINUE_EDITING' | translate }}</button>
                <button type="button" class="btn btn-confirm" data-dismiss="modal" (click)="returnToOverview()">{{ 'CHECK.RETURN_OVERVIEW' | translate }}</button>
            </div>
        </div>
    </div>
</div>